import {
    type GetUploadTokenForUserProfilePhotoResponseType,
    type GetUploadTokenForUserProfilePhotoRequestType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForUserProfilePhoto = async (params: GetUploadTokenForUserProfilePhotoRequestType): Promise<GetUploadTokenForUserProfilePhotoResponseType> => {
    return await request<GetUploadTokenForUserProfilePhotoResponseType>("/user/getUploadTokenForUserProfilePhoto", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForUserProfilePhoto;
